import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import cx from 'classnames';
import './styles.sass';
import SimpleMdeReact from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import IconSvg from 'components/IconSvg';
import IconButton from 'components/IconButton';
import ChatFormatting from 'assets/icons/chat-formatting.i.svg';
import AIPrompt from 'assets/icons/ai-prompt.i.svg';
import JobTaxAssistantPromptPicker from '../JobTaxAssistantPromptPicker';
export var MessageComposer = function MessageComposer(props) {
  var border = props.border,
    disabled = props.disabled,
    onChange = props.onChange,
    onSend = props.onSend,
    value = props.value,
    downloadConversation = props.downloadConversation,
    disableNotes = props.disableNotes,
    jobTaxAssistantPrompts = props.jobTaxAssistantPrompts,
    onJobTaxAssistantPromptClick = props.onJobTaxAssistantPromptClick;
  var isJobTaxAssistantToolbarEnabled = (jobTaxAssistantPrompts === null || jobTaxAssistantPrompts === void 0 ? void 0 : jobTaxAssistantPrompts.length) > 0;
  var _React$useReducer = React.useReducer(function (state, newState) {
      return _objectSpread(_objectSpread({}, state), newState);
    }, {
      mdeInstance: null,
      isEmojiPickerOpen: false,
      isNoteMode: false,
      isToolBarHidden: isJobTaxAssistantToolbarEnabled,
      isJobTaxAssistantPromptPickerOpen: false
    }),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    setState = _React$useReducer2[1];
  var getMdeInstance = React.useCallback(function (mde) {
    return setState({
      mdeInstance: mde
    });
  }, []);
  function addEmoji(emoji) {
    var _state$mdeInstance;
    var codemirror = (_state$mdeInstance = state.mdeInstance) === null || _state$mdeInstance === void 0 ? void 0 : _state$mdeInstance.codemirror;
    if (codemirror) {
      codemirror.replaceSelection(emoji.native);
      onChange(codemirror.getValue());
    }
    setState({
      isEmojiPickerOpen: !state.isEmojiPickerOpen
    });
  }
  var options = React.useMemo(function () {
    return {
      autoDownloadFontAwesome: true,
      placeholder: 'Press Shift + Enter for new lines.',
      minHeight: '25px',
      spellChecker: false,
      status: false,
      toolbar: state.isToolBarHidden ? false : [isJobTaxAssistantToolbarEnabled && {
        name: 'close-toolbar',
        className: 'fa fa-times-circle',
        title: 'Hide toolbar',
        action: function action() {
          setState({
            isToolBarHidden: true,
            isEmojiPickerOpen: false
          });
        }
      }, 'bold', 'italic', 'strikethrough', 'heading-1', 'heading-2', 'code', 'unordered-list', 'ordered-list', 'link', 'image', {
        name: 'emoji',
        action: function action() {
          setState({
            isEmojiPickerOpen: !state.isEmojiPickerOpen
          });
        },
        className: 'fa fa-smile-o',
        title: 'Emojis'
      }, !disableNotes && {
        name: 'note',
        action: function action() {
          setState({
            isNoteMode: !state.isNoteMode
          });
        },
        className: 'fa fa-sticky-note',
        title: 'Notes'
      }, {
        name: 'download',
        className: 'fa fa-download',
        title: 'Download Conversation',
        action: function action() {
          downloadConversation();
        }
      }].filter(Boolean)
    };
  }, [state.isNoteMode, state.isEmojiPickerOpen, state.isToolBarHidden]);
  var events = React.useMemo(function () {
    // Using events rather than extraKeys parameter
    // do to an issue we could not figure out
    // https://github.com/RIP21/react-simplemde-editor/issues/183
    // Link above says it's fixed but still experiencing it in 5.2.0
    return {
      keyHandled: function keyHandled(editor, event) {
        if (event === 'Enter') {
          var _stat$type;
          var pos = editor.getCursor('start');
          var stat = editor.getTokenAt(pos);
          if ((_stat$type = stat.type) !== null && _stat$type !== void 0 && _stat$type.includes('variable-2')) {
            onChange(editor.getValue());
          } else {
            onSend(state.isNoteMode);
            // so they internally set a state which forces a rerender. but when
            // you hit the enter key the actual value of the field does not change and there is no rerender
            editor.setValue(value);
          }
        }
      }
    };
  }, [state.isNoteMode]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('message-composer', disabled && 'is-disabled', border && 'has-border', state.isNoteMode && 'note', isJobTaxAssistantToolbarEnabled && 'has-toolbar-toggle'),
    "data-test": "message-composer"
  }, /*#__PURE__*/React.createElement(Picker, {
    style: {
      position: 'absolute',
      left: '10px',
      top: '-312px',
      visibility: state.isEmojiPickerOpen ? 'visible' : 'hidden'
    },
    onSelect: addEmoji
  }), isJobTaxAssistantToolbarEnabled && state.isJobTaxAssistantPromptPickerOpen && /*#__PURE__*/React.createElement(JobTaxAssistantPromptPicker, {
    prompts: jobTaxAssistantPrompts,
    onPromptClick: onJobTaxAssistantPromptClick,
    onClose: function onClose() {
      return setState({
        isJobTaxAssistantPromptPickerOpen: !state.isJobTaxAssistantPromptPickerOpen
      });
    }
  }), state.isToolBarHidden && /*#__PURE__*/React.createElement(AIToolbar, {
    openEditor: function openEditor() {
      return setState({
        isToolBarHidden: false,
        isJobTaxAssistantPromptPickerOpen: false
      });
    },
    togglePrompts: function togglePrompts() {
      return setState({
        isJobTaxAssistantPromptPickerOpen: !state.isJobTaxAssistantPromptPickerOpen
      });
    }
  }), /*#__PURE__*/React.createElement(SimpleMdeReact, {
    className: "editor",
    value: value,
    events: events,
    options: options,
    getMdeInstance: getMdeInstance,
    onChange: onChange
  }));
};
var AIToolbar = function AIToolbar(props) {
  var openEditor = props.openEditor,
    togglePrompts = props.togglePrompts;
  return /*#__PURE__*/React.createElement("div", {
    className: "job-tax-assistant-toolbar"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: openEditor
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 24
  }, /*#__PURE__*/React.createElement(ChatFormatting, null))), /*#__PURE__*/React.createElement(IconButton, {
    onClick: togglePrompts
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 16
  }, /*#__PURE__*/React.createElement(AIPrompt, null))));
};
//# sourceMappingURL=index.js.map
